// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-1POSs";
var _4 = "card-2q91y";
var _5 = "card_aggregator-2t92G";
var _6 = "title-3heFk";
var _7 = "summaryOption__name-1oGei";
var _8 = "summaryOption__money-sUbEq";
var _9 = "modal__paper-qU9wl";
var _a = "modal__topWrapper-nByz0";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "card", _5 as "card_aggregator", _6 as "title", _7 as "summaryOption__name", _8 as "summaryOption__money", _9 as "modal__paper", _a as "modal__topWrapper" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "card": _4, "card_aggregator": _5, "title": _6, "summaryOption__name": _7, "summaryOption__money": _8, "modal__paper": _9, "modal__topWrapper": _a }
